import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  private apiUrl = environment.apiURL + 'clients'; // URL del API

  constructor(private http: HttpClient) {}

  getData(pageNumber: number = 0, pageSize: number = 0): Observable<any> {
    return this.http.get(
      `${this.apiUrl}?page=${pageNumber}&pageSize=${pageSize}`
    );
  }

  // Método para añadir datos a la API
  addData(item: any): Observable<any> {
    return this.http.post(this.apiUrl + '/new', item);
  }

  getDataAccounts(): Observable<any> {
    return this.http.get(environment.apiURL + 'accounts');
  }

  deleteClient(reference: string): Observable<any> {
    return this.http.delete(this.apiUrl + `/${reference}` + '/delete');
  }

  updateClient(reference: string, clientData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${reference}` + '/update', clientData);
  }

  getClientByReference(reference: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${reference}`);
  }

  searchClients(search: string): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}?search=${search}`);
  }

  getClientsByType(
    type: string,
    pageNumber: number = 0,
    pageSize: number = 0
  ): Observable<any> {
    return this.http.get<any[]>(
      `${this.apiUrl}?type[eq]=${type}&page=${pageNumber}&pageSize=${pageSize}`
    );
  }

  getClients(params: {
    search?: string;
    type?: string;
    page: number;
    pageSize: number;
  }): Observable<any> {
    let httpParams = new HttpParams()
      .set('page', params.page.toString())
      .set('pageSize', params.pageSize.toString());

    if (params.search) {
      httpParams = httpParams.set('search', params.search);
    }

    if (params.type) {
      httpParams = httpParams.set('type[eq]', params.type);
    }

    return this.http.get<any>(this.apiUrl, { params: httpParams });
  }

  checkTaxId(taxId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/search/tax-id/${taxId}`);
  }

  uploadDocument(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/search/documents`, formData);
  }

  getClientsOrders(reference: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${reference}/orders`);
  }

  private assigneeCreatedSource = new Subject<any>();
  assigneeCreated$ = this.assigneeCreatedSource.asObservable();

  emitAssigneeCreated(assignee: any) {
    this.assigneeCreatedSource.next(assignee);
  }


  private guaranteeCreatedSource = new BehaviorSubject<any>(null);
  guaranteeCreated$ = this.guaranteeCreatedSource.asObservable();

  emitGuaranteeCreated(data: { guarantee: any; orderReference?: string }) {
    this.guaranteeCreatedSource.next(data);
  }

  private clientCreatedSource = new BehaviorSubject<any>(null);
  clientCreated$ = this.clientCreatedSource.asObservable();


  setClient(data: { client: any; orderReference?: string }) {
    this.clientCreatedSource.next(data);
  }

  emitClientCreated(data: { client: any; orderReference?: string }) {
    this.clientCreatedSource.next(data);
  }
  resetClient() {
    this.clientCreatedSource.next(null);
  }
  resetGuarantee() {
    this.guaranteeCreatedSource.next(null);
  }


}
